export default __webpack_public_path__ + "img/allergy-celery.601024497227678bfa8ccb9756a968e2.svg";